import React from 'react';
import RoomDetails from '../../ReservationSegmentCard/tabs/RoomDetails';
import DateHelper from '../../DateHelper/DateHelper';
import { format, isSameDay, parseISO } from 'date-fns';
import clsx from "clsx";

export default class ServiceLogPresenterGeneral extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      numberFormat: '0' + ($('#delimiter').val() || ',') + '0' + ($('#separator').val() || '.') + '00',
      dateFormat: DateHelper.rubyToDateFNS(this.props.date_format),
      timeFormat: DateHelper.rubyToDateFNS(this.props.time_format),
    }
  }

  render() {

    var tabClasses = clsx({
      'active': this.props.active_tab == 'service-log-general',
      'tab-pane': true
    })
    if (this.props.reservation_segment) {
      var reservation_segment = this.props.reservation_segment
      var check_in_date = new Date(this.props.reservation_segment.check_in_date)
      var today = new Date()

      var check_in_today = isSameDay(parseISO(this.props.reservation_segment.check_in_date), today) && this.props.reservation_segment.status != "checked_in"
      var check_out_today = isSameDay(parseISO(this.props.reservation_segment.check_out_date), today) && this.props.reservation_segment.status == "checked_in"

    };

    return(
      <div className={tabClasses} id="service-log-general">
        <div>
            <div className="row" style={{marginBottom: 15}}>
              <div className="col-sm-4 form-group">
                <label>{I18n.t('scheduled')}</label>
                <br />
                <div>
                  {format(parseISO(this.props.service_log.scheduled_at), DateHelper.rubyToDateFNS(this.props.date_format))}
                </div>
              </div>
              <div className="col-sm-4 form-group">
                <label>{I18n.t('status')}</label>
                <br />
                <div>
                  {I18n.t(this.props.service_log.status)}
                </div>
              </div>
            </div>

            <div className="row">
              {
                this.props.service_log.setTimeOpen
                ?
                <div className="col-sm-4 pull-left" >
                  <div className="form-group pull-left" >
                    <label>{I18n.t('between')}</label>
                    <br />
                    <div>
                      {this.props.service_log.startTime ? DateHelper.printDateToScreen(this.props.service_log.startTime, this.props.time_format, true) : null}
                    </div>
                    <label>{I18n.t('and')}</label>
                    <div>
                      {this.props.service_log.endTime ? DateHelper.printDateToScreen(this.props.service_log.endTime, this.props.time_format, true) : null}
                    </div>
                  </div>
                </div>
                :
                null
              }
            </div>
            <hr />
          <div className="row">
            <div className="col-sm-4 form-group">
              <label>{`${I18n.t('service_request_description')}`}</label>
              <br />
              <div>
                {this.props.service_log.description}
              </div>
            </div>
            {
              this.props.service_log.products && this.props.service_log.products.length > 0
                ?
                <div className="col-sm-4 form-group">
                  <label>{`${I18n.t('product_description')}`}</label>
                  <br />
                  <div>{this.props.service_log.products[0].description}</div>
                </div>

                :
              null
            }
          </div>
          <hr className="hr" />
          <div className="row">
          {
            this.props.reservation_segment
            ?
            <RoomDetails {...this.props} check_in_date={check_in_date} today={today} check_in_today={check_in_today} check_out_today={check_out_today} read_only={true} />
            :
            null
          }
          </div>
        </div>
     </div>
    );
  };

};
